import { useEffect, useState } from "react";
import { useAppSelector } from "../../framework/redux/hooks";
import { appOptionSelectors } from "../../framework/redux/slices/appSlice";
import { TypedOption } from "../../models/common/typedOptions";

export const useAppOptionValue = <T>(code: string): [T, boolean] => {
    const [value, setValue] = useState<T>();
    const [loading, setLoading] = useState<boolean>(true);
    const optionsState = useAppSelector((state) => state.app.options);
    const option = appOptionSelectors.selectById(optionsState, code.toLowerCase());
    const { loading: optionsLoading } = optionsState;

    useEffect(() => {
        setValue(<T>new TypedOption(option).getTypedValue());
    }, [option, code]);

    useEffect(() => {
        if (loading !== optionsLoading) {
            setLoading(optionsLoading);
        }
    }, [optionsLoading]);

    return [value, loading];
};

export const useAppOptionValueEquals = (
    code: string,
    value: any
): [boolean, boolean] => {
    const [optionValue, loading] = useAppOptionValue(code);
    return [optionValue === value, loading];
};
